var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 10C10.1642 10 10.5 10.3358 10.5 10.75V16.75C10.5 17.1642 10.1642 17.5 9.75 17.5C9.33579 17.5 9 17.1642 9 16.75V10.75C9 10.3358 9.33579 10 9.75 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 10C14.6642 10 15 10.3358 15 10.75V16.75C15 17.1642 14.6642 17.5 14.25 17.5C13.8358 17.5 13.5 17.1642 13.5 16.75V10.75C13.5 10.3358 13.8358 10 14.25 10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 5.5C5.66421 5.5 6 5.83579 6 6.25V20.5H18V6.25C18 5.83579 18.3358 5.5 18.75 5.5C19.1642 5.5 19.5 5.83579 19.5 6.25V20.5C19.5 20.8978 19.342 21.2794 19.0607 21.5607C18.7794 21.842 18.3978 22 18 22H6C5.60218 22 5.22065 21.842 4.93934 21.5607C4.65804 21.2794 4.5 20.8978 4.5 20.5V6.25C4.5 5.83579 4.83579 5.5 5.25 5.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15901 3.15901C8.58097 2.73705 9.15326 2.5 9.75 2.5H14.25C14.8467 2.5 15.419 2.73705 15.841 3.15901C16.2629 3.58097 16.5 4.15326 16.5 4.75V6.25C16.5 6.66421 16.1642 7 15.75 7C15.3358 7 15 6.66421 15 6.25V4.75C15 4.55109 14.921 4.36032 14.7803 4.21967C14.6397 4.07902 14.4489 4 14.25 4H9.75C9.55109 4 9.36032 4.07902 9.21967 4.21967C9.07902 4.36032 9 4.55109 9 4.75V6.25C9 6.66421 8.66421 7 8.25 7C7.83579 7 7.5 6.66421 7.5 6.25V4.75C7.5 4.15326 7.73705 3.58097 8.15901 3.15901Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 5.50001L20.25 5.5C20.6642 5.5 21 5.83579 21 6.25C21 6.66421 20.6642 7 20.25 7L3.75 7.00001C3.33579 7.00001 3 6.66422 3 6.25001C3 5.83579 3.33579 5.50001 3.75 5.50001Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewDelete);
export default __webpack_public_path__ + "static/media/PreviewDelete.f1e1a1afcc475ea0bae530237e753c15.svg";
export { ForwardRef as ReactComponent };